import styled from 'styled-components';
import Image from '@mlb/react-patterns/v4/components/Image/image';
import GDBREAKPOINTS from '@gameday/components/themes/breakpoints';
import { CloseButton } from '../Overlay/overlay.style';
import Link from '@mlb/react-patterns/v4/components/Link/link';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';

const { XS_MAX } = GDBREAKPOINTS;

const {
    mlbWhite
} = COLORS;

export const Banner = styled(Image)`
    display: block;
    line-height: 0;
`;

export const Description = styled.p`
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    margin: 0;
    color: var(--gameday-primary-font-color);

    @media (max-width: ${XS_MAX}) {
        font-size: 16px;
    }
`;

export const InterstitialLink = styled(Link)`
    color: #fff!important;
    background-color: var(--gameday-button-solid-background);
    padding: 16px 32px;
    border-radius: 32px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    display: block;
    margin: 0 auto;

    &:hover {
        color: #fff!important;
    }
`;

export const ContentWrap = styled.div`
    padding: ${({ $isPadded }) => $isPadded ? 'var(--gameday-section-padding-sm) 48px' : 'var(--gameday-section-padding-sm)'};
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: var(--gameday-section-padding-sm);
`;

export const InterstitialClose = styled(CloseButton)`
    position: absolute;
    top: 16px;
    right: 8px;
    width: 32px;
    &:hover {
        background-color: transparent;
    }
    svg {
        stroke: none;
        path {
            fill: ${({ isWhite }) => isWhite ? `${mlbWhite};` : 'var(--gameday-primary-font-color)'};
        }
    }
    &:hover {
        svg {
            path {
                fill: ${({ isWhite }) => isWhite ? `${mlbWhite};` : 'var(--gameday-primary-font-color)'};

            }
        }
    }
`;
